<template lang="pug">
extends ../Base/Card.pug

block card-header
    div.card-header-title
        h2.title {{ title || $t('common.unknown') }}
    div.lifetime
        //- show lifetime, or empty span to level the card-header height on views where many cards are aligned
        span(v-if="actor && actor.BirthYear") {{ getActorLifetime(actor) }}
        span.nbsp-block(v-else) &nbsp;
    div.artworks-counted
        span(v-if="actor && actor.ArtworksCounted") {{ $tc('artworks.search.resultCount', actor.ArtworksCounted, {count: actor.ArtworksCounted}) }}
        span.nbsp-block(v-else) &nbsp;


block card-contents
    slot


block card-social
    div.social-actions(v-if="social && actor")

        social-follow(
            resource="actors"
            v-bind:item="actor")


</template>

<script>
import BaseCard from '@/components/Base/Card';

export default {
    name: 'actor-card',

    extends: BaseCard,

    props: {
        className: {    type: String, default: 'actor-card' },
        resolution: {   type: Object, default: () => { return {x: 'auto', y: 'auto'}; } } // needed for image-box wrapper height
    },

    data: function () {
        return {
            resource: 'actors',
            actor: null
        };
    },

    mounted: function () {
        // Note: the item may not be complete.
        // For instance from the Artwork page the Actor contains just
        // Id, Name and Role.
        if (!this.item) {
            return;
        }
        if (this.item.ActorType) {
            this.actor = this.item;
        }
        else if (this.item.Actor) {
            this.actor = this.item.Actor;
        }
        else if (this.item.Role) {
            this.actor = this.item;
        }
        else if (this.item.ActorSortName) {
            this.actor = this.item;
        }
        else if (this.item.ActorName) {
            this.actor = this.item;
        }
    },

    methods: {
        getCardRoute: function (item) {
            return this.getRoute(
                item, {section: 'info-artworks'}, 'Actor');
        },

        /**
         * Get image for the Card.
         */
        getCardImageSrc: function (item, imageAttrs) {
            return this.$helpers.getActorIngressImageSrc(item, imageAttrs);
        },

        getStyle: function () {
            return '';
        }
    }
};
</script>

<style lang="scss">
// @import '~assets/styles/mixins';

.actor-card {
    display: inline-block !important;
    &.card .card-header {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: auto;
        margin-top: 0.5rem;
        text-align: center;
        align-items: center; /* Keskittää lapset pystysuunnassa */
        align-self: center; /* Keskittää itsensä ylemmän kontainerin sisällä */
    }
    &.card .card-header .card-header-title {
        min-width: unset;
        margin: 0.25rem 0;
        font-family: $helvetica-roman;
        font-weight: normal;
        text-align: center;
    }
    .artwork-sidebar &.card .card-header .card-header-title {
        text-align: left;
    }
    .card-link {
        text-decoration: none;
        cursor: pointer;
        .card-header-title {
            cursor: pointer;
        }
    }
    .nationality, .lifetime, .actor-type, .artworks-counted {
        font-family: $helvetica-roman;
        font-size: 1rem;
    }
    .card-image {
        flex-grow: 0;
    }
    .card-image .image {
        @include actor-circle;
        transform: height;
        transition-duration: 500ms;
    }
    .social {
        right: 0;
        display: flex;
        margin: 0 0 auto auto;
        margin-left: auto;
    }
}
</style>
